import Vue from 'vue'
import Auth from '../components/auth';
import Main from '../components/main';
import Router from 'vue-router'
import beforeEach from './beforeEach'
import { routes as auth } from '../app/auth'
import { routes as mainRoutes } from '../app'
import { routes as mainRoutesC } from '../app/c'

Vue.use(Router)

// https://developer.mozilla.org/pt-BR/docs/Web/JavaScript/Reference/Operators/Spread_operator
const routes = [
    {
        name: 'lms/login',
        path: '/lms/login',
        component: Auth,
        meta: { requiresAuth: false },
        children: [ ...auth],
        redirect: { name: 'auth.login' }
    },
    {
        path: '/',
        component: Main,
        // meta: { requiresAuth: true },
        meta: { requiresAuth: false },
        children: [ ...mainRoutes],
        redirect: { name: 'dashboard.index' }
    },
    {
        path: '/c',
        component: Auth,
        meta: { requiresAuth: false },
        children: [ ...mainRoutesC],
        redirect: { name: 'c.login' }
    },
    {
        name: 'catchall',
        path: '*',
        redirect: { name: 'dashboard.index' }
    },
]

const router = new Router({
    routes,
    linkActiveClass: 'active',
    mode: 'history', // do not use /#/.
});

/**
* Before a route is resolved we check for
* the token if the route is marked as
* requireAuth.
*/
router.beforeEach(beforeEach)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js